<template>
    <div id="wrap">
        <PubHeader></PubHeader>
        
        <div id="container">
            <router-view></router-view>
        </div>
        
        <PubFooter></PubFooter>
    </div>
</template>

<script>
import PubHeader from './PubHeader';
import PubFooter from './PubFooter';

export default {
  name: 'Layout-Default',
  components: {
    PubHeader,
    PubFooter
  },

}
</script>



// WEBPACK FOOTER //
// src/components/view/markup/layout/LayoutDefault.vue